/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {ColumnManager} from './column-manager';

export class ColumnGroup {
  public title: string;
  public columns: ColumnManager[] = [];
  public width: number;
  public firstVisible = 0;
  public noGroup: boolean;
  public isFixed: boolean;
  public fixedLeftOffset = 0;
  public fixedColumnWidth = 0;

  constructor(title: string, columns?: ColumnManager[], noGroup = false) {
    this.title = title;
    if (columns) {
      this.columns = columns;
    }
    this.width = 0;
    this.noGroup = noGroup;
  }

  refreshWidth() {
    let width = 0;
    let index = 0;
    this.firstVisible = -1;
    for (const c of this.columns) {
      if (c.showOnTable) {
        width += c.width;
        if (this.firstVisible < 0) {
          this.firstVisible = index;
        }
      }
      ++ index;
    }
    this.width = width;
    if (this.isFixed) {
      this.fix(this.fixedLeftOffset);
    }
  }

  public fix(left = 0): number {
    this.isFixed = true;
    this.fixedLeftOffset = left;
    this.columns.forEach((c) => {
      if (c.showOnTable) {
        c.fix(left);
        left += c.width;
      }
    });
    return left;
  }

  public refreshFixedWidth(offset: number): number {
    this.fixedLeftOffset = offset;
    let width = 0;
    for (const c of this.columns) {
      if (c.isFixed) {
        width += c.width;
      }
    }
    this.fixedColumnWidth = width;
    return width;
  }

  unfix() {
    this.isFixed = false;
    this.fixedLeftOffset = 0;
    this.columns.forEach((c) => {
      if (c.showOnTable) {
        c.isFixed = false;
      }
    });
  }
}
